import React from "react";

const BartelSkala = () => {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        aria-label="Barhtelov index"
        title="Barhtelov index"
        frameBorder="0"
        style={{ marginTop: "100px", height: "100%", width: "100%", border: "none" }}
        src="https://forms.zohopublic.eu/domfamilia1/form/Barhtelovindex/formperma/MtLAn9KE5xb3xefnC7luE1-aE8V0jCPRxIEjVBORgkU"
      />
    </div>
  );
};

export default BartelSkala;
export { BartelSkala };

